var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExperience(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1232_5452",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1232_5452)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.04989 10.8333L7.99989 9.64995L9.94989 10.8333L9.43322 8.61662L11.1666 7.11662L8.88322 6.93328L7.99989 4.83328L7.11655 6.93328L4.83322 7.11662L6.56655 8.61662L6.04989 10.8333ZM8.01655 15.9833L5.69989 13.75H2.24989V10.3L-0.0334473 7.99995L2.24989 5.69995V2.23328H5.69989L8.01655 -0.0500488L10.2999 2.23328H13.7666V5.69995L16.0499 7.99995L13.7666 10.3V13.75H10.2999L8.01655 15.9833ZM8.01655 13.7833L9.64855 12.1833H12.1832V9.63329L13.8332 7.99995L12.1832 6.34995V3.81662H9.64989L8.01655 2.16662L6.36655 3.81662H3.81655V6.34995L2.18322 7.99995L3.81655 9.63329V12.1833H6.34989L8.01655 13.7833Z",
    fill: "#172128"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperience);
export default __webpack_public_path__ + "static/media/experience.1568ad9468af5c98c8deda9931144dda.svg";
export { ForwardRef as ReactComponent };